"use strict";

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.function.name");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib"); // @ts-nocheck


var format_1 = tslib_1.__importDefault(require("./format"));

var enums_1 = require("../enums");

var INVALID_MODIFIER_ERROR = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';
var MISSING_DEPENDENCY_ERROR = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available';
var VALID_PROPERTIES = ['name', 'enabled', 'phase', 'fn', 'effect', 'requires', 'options'];
/**
 * @param modifiers
 */

function validateModifiers(modifiers) {
  modifiers.forEach(function (modifier) {
    Object.keys(modifier).forEach(function (key) {
      switch (key) {
        case 'name':
          if (typeof modifier.name !== 'string') {
            console.error(format_1["default"](INVALID_MODIFIER_ERROR, String(modifier.name), '"name"', '"string"', "\"".concat(String(modifier.name), "\"")));
          }

          break;

        case 'enabled':
          if (typeof modifier.enabled !== 'boolean') {
            console.error(format_1["default"](INVALID_MODIFIER_ERROR, modifier.name, '"enabled"', '"boolean"', "\"".concat(String(modifier.enabled), "\"")));
          }

        case 'phase':
          if (enums_1.modifierPhases.indexOf(modifier.phase) < 0) {
            console.error(format_1["default"](INVALID_MODIFIER_ERROR, modifier.name, '"phase"', "either ".concat(enums_1.modifierPhases.join(', ')), "\"".concat(String(modifier.phase), "\"")));
          }

          break;

        case 'fn':
          if (typeof modifier.fn !== 'function') {
            console.error(format_1["default"](INVALID_MODIFIER_ERROR, modifier.name, '"fn"', '"function"', "\"".concat(String(modifier.fn), "\"")));
          }

          break;

        case 'effect':
          if (typeof modifier.effect !== 'function') {
            console.error(format_1["default"](INVALID_MODIFIER_ERROR, modifier.name, '"effect"', '"function"', "\"".concat(String(modifier.fn), "\"")));
          }

          break;

        case 'requires':
          if (!Array.isArray(modifier.requires)) {
            console.error(format_1["default"](INVALID_MODIFIER_ERROR, modifier.name, '"requires"', '"array"', "\"".concat(String(modifier.requires), "\"")));
          }

          break;

        case 'requiresIfExists':
          if (!Array.isArray(modifier.requiresIfExists)) {
            console.error(format_1["default"](INVALID_MODIFIER_ERROR, modifier.name, '"requiresIfExists"', '"array"', "\"".concat(String(modifier.requiresIfExists), "\"")));
          }

          break;

        case 'options':
        case 'data':
          break;

        default:
          console.error("PopperJS: an invalid property has been provided to the \"".concat(modifier.name, "\" modifier, valid properties are ").concat(VALID_PROPERTIES.map(function (s) {
            return "\"".concat(s, "\"");
          }).join(', '), "; but \"").concat(key, "\" was provided."));
      }

      modifier.requires && modifier.requires.forEach(function (requirement) {
        if (modifiers.find(function (mod) {
          return mod.name === requirement;
        }) == null) {
          console.error(format_1["default"](MISSING_DEPENDENCY_ERROR, String(modifier.name), requirement, requirement));
        }
      });
    });
  });
}

exports["default"] = validateModifiers;